import React from "react";
import { ECLThemeImage } from "../../../index";
import { translate } from "../../../../utilities/Translate";

// Change the state of the parents sortOption
export default function CommentsSortButton({ sortBy, setSortBy, toggleSort }) {
   function handleClick(e) {
      setSortBy(e.target.value);
      toggleSort(e.target.value);
   }
   const newButton = (
      <button
         className={"comment-sort-button"}
         value={"asc"}
         onClick={handleClick}
      >
         <p>{translate("Newest First")}</p>
         <ECLThemeImage
            fontAwesome="chevron-down"
            alt={translate("Sort Ascending")}
         />
      </button>
   );
   const oldButton = (
      <button
         className={"comment-sort-button"}
         value={"desc"}
         onClick={handleClick}
      >
         <p>{translate("Oldest First")}</p>
         <ECLThemeImage
            fontAwesome="chevron-up"
            alt={translate("Sort Descending")}
         />
      </button>
   );
   return (
      <div className="comments-sort">
         {sortBy === "desc" ? newButton : oldButton}
      </div>
   );
}
